



















































import {
    defineComponent,
    ref,
    PropType,
    computed,
    toRefs,
    Ref,
    onBeforeUnmount,
    onMounted,
} from '@vue/composition-api';
import Swiper from '@/pure-components/swiper/index.vue';
import FeedVideo from './video.vue';
import Report from '@/components/business-block/report/index.vue';
import ErrorVideo from './error.vue';
import { Feed, Maybe } from '@/generated-models';
import FeedComment from './comment.vue';
import Toast from '@/components/toast/index.vue';
import { PhotoPackage, SwitchType } from '../types';
import { useApolloModel } from 'vue-apollo-model';
import CommentModel from '@/components/comment/commentModel';
import { useBroadCastStream } from '@/common/utils';
import { useVideoLog } from '../hooks/useVideoLog';
import { appendLogInfo, useLog } from '@/common/log';
import { useFeed, useSwiper } from '../hooks/useFeed';
export default defineComponent({
    name: 'newRecoFeed',
    props: {
        feed: {
            type: Array as PropType<Maybe<Feed>[]>,
        },
        logType: {
            type: String,
            default: '',
        },
        llsid: String,
    },
    components: {
        Swiper,
        FeedVideo,
        FeedComment,
        Toast,
        Report,
        ErrorVideo,
    },
    setup(props, { emit }) {
        const log = useLog();
        const commentModel = useApolloModel(CommentModel);
        const playerToast: Ref<InstanceType<typeof Toast> | null> = ref(null);
        const errorText = ref('作品已失效');
        const feedList = computed(() => props.feed);
        const swiperRef: Ref<InstanceType<typeof Swiper> | null> = ref(null);
        const swiperOptions = useSwiper();
        const { state, commentCount, beginTime } = useFeed(swiperRef, feedList, playerToast);
        const curFeedItem = computed(() => props.feed && props.feed[state.activeIndex]);
        const photoPackage = computed(() => {
            return {
                type: 'PHOTO',
                identity: curFeedItem.value?.photo?.id || '',
                s_author_id: curFeedItem.value?.author?.id || '',
                exp_tag: curFeedItem.value?.photo?.expTag || '',
                index: state.activeIndex + 1,
                llsid: props.llsid,
            } as PhotoPackage;
        });
        const { sendVideoLog } = useVideoLog(log, photoPackage, beginTime);
        const curVideoDuration = computed(() => curFeedItem.value?.photo?.duration || 0);

        const allFeedNum = computed(() => props.feed?.length || 0);

        function sendPlayLog() {
            sendVideoLog(curVideoDuration.value);
        }
        function slideChange(index: number) {
            sendPlayLog();
            state.switchDirection = state.activeIndex < index ? 'down' : 'up';
            state.activeIndex = index;
            commentModel.photoId = props.feed && props.feed[state.activeIndex]?.photo?.id || '';
            if (allFeedNum.value === index + 4) {
                emit('fetch-more');
            }
            log({
                type: 'CLICK',
                event_name: 'VIDEO_SWITCHING',
                event_value: {
                    slip_type: state.switchDirection.toUpperCase(),
                    switch_type: state.slideChangeType.toUpperCase() || 'SLIPPING',
                },
            });
            state.slideChangeType = '';
        }
        function handleFeedChange(type: SwitchType) {
            state.slideChangeType = 'KNOCKING';
            if (type === 'up') {
                swiperRef.value?.swiper?.slidePrev();
            } else {
                swiperRef.value?.swiper?.slideNext();
            }
        }

        function handleClickSidebar(type: string) {
            if (type === 'comment') {
                state.showCommentPanel = !state.showCommentPanel;
            }
        }
        function handleCommentHide() {
            state.showCommentPanel = false;
        }
        function handleMuted(val: boolean) {
            state.muted = val;
        }
        function handleFullscreen(isFullscreen: boolean) {
            state.isFullscreen = isFullscreen;
        }
        function handleCopyShare() {
            playerToast.value?.show('复制成功', 2000);
        }
        function handleFeedback() {
            playerToast.value?.show('已为您减少此类视频播放', 1500);
            swiperRef.value?.swiper?.slideNext();
        }
        function handleCommentEnter(enter: boolean) {
            if (enter) {
                swiperRef.value?.swiper?.mousewheel.disable();
            } else {
                swiperRef.value?.swiper?.mousewheel.enable();
            }
        }
        useBroadCastStream('showLogin', (info: { show: boolean }) => {
            if (info.show) {
                swiperRef.value?.swiper?.disable();
            } else {
                swiperRef.value?.swiper?.enable();
            }
        });
        onMounted(() => {
            window.addEventListener('beforeunload', sendPlayLog);
        });

        onBeforeUnmount(() => {
            window.removeEventListener('beforeunload', sendPlayLog);
        });

        appendLogInfo(info => {
            return {
                ...info,
                event_value: {
                    ...info.event_value,
                },
                event_content: {
                    ...info.event_content,
                    photo_package: photoPackage.value,
                },
            };
        });

        return {
            ...toRefs(state),
            swiperRef,
            swiperOptions,
            commentCount,
            playerToast,
            errorText,
            curFeedItem,
            slideChange,
            handleFeedChange,
            handleClickSidebar,
            handleFeedback,
            handleCommentEnter,
            handleCopyShare,
            handleCommentHide,
            handleMuted,
            handleFullscreen,
        };
    },
});
